import styled from 'styled-components';

export const UserInfo = styled.div`
  margin-right: 10px;
  font-size: 20px;
  a {
    color: #fff;
  }
`;
